module.exports = __webpack_public_path__ + "img/ieee-xplore-logo.1f61af4f.png";